import {Component, Input, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {Observable, of} from 'rxjs';

import {ProductService} from '../../../../services/product.service';
import {Product} from '../../../../models/product.model';


@Component({
    selector: 'app-inventory-allocation-status',
    templateUrl: './inventory-allocation-status.component.html',
    styleUrls: ['./inventory-allocation-status.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager
})
export class InventoryAllocationStatusComponent implements OnInit {

  @Input() product: Product;

  @Input() skuId?: number;

  someVariationsHasAllocationInventory$: Observable<boolean>;
  allocationInventoryQuantity$: Observable<{inStock: boolean, totalQty: number}>
  fetchingAllocationInventory$: Observable<boolean>;

  constructor(private productService: ProductService) {}

  get enabled(): boolean {
    return this.product.isEnabledAllocatedInventory === true && this.product.isBuyingWindow === false;
  }

  ngOnInit() {
    this.someVariationsHasAllocationInventory$ = this.getSomeVariationsHasAllocationInventory$();
    this.allocationInventoryQuantity$ = this.productService.computeTotalAvailableQuantity$(this.product?.id, this.skuId);
    this.fetchingAllocationInventory$ = this.productService.isFetchingProductAllocations$(this.product?.id);
  }


  getSomeVariationsHasAllocationInventory$(): Observable<boolean> {
    if (this.product?.hasVariations) {
      return  this.productService.someVariationsHasAllocationGroups(this.product?.id);
    }
    return of(false);
  }

}
